import { AfterContentInit, ContentChildren, Directive, Input, QueryList } from '@angular/core';
import { NG_VALIDATORS, NgModel, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[nspGreaterThan]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: AGreaterThanBDirective,
      multi: true,
    },
  ],
})
export class AGreaterThanBDirective implements Validator, AfterContentInit {
  @Input('nspGreaterThan') index!: number;
  @Input() controlAId!: string;
  @Input() controlBId!: string;

  @ContentChildren(NgModel, { descendants: true })
  models!: QueryList<NgModel>;

  private controlA?: NgModel;
  private controlB?: NgModel;

  ngAfterContentInit() {
    this.controlA = this.models.find((m) => m.name === this.controlAId);
    this.controlB = this.models.find((m) => m.name === this.controlBId);

    if (this.controlA && this.controlB) {
      this.controlA.valueChanges?.subscribe(() => {
        this.validateAndSetErrors();
      });

      this.controlB.valueChanges?.subscribe(() => {
        this.validateAndSetErrors();
      });
    }
  }

  private validateAndSetErrors() {
    const current = this.controlA?.control.value;
    const previous = this.controlB?.control.value;

    if (current < previous) {
      this.controlA?.control.setErrors({ aLessThanB: true });
      this.controlB?.control.setErrors({ aLessThanB: true });
    } else {
      if (this.controlA?.control.hasError('aLessThanB')) {
        this.controlA?.control.setErrors(null);
      }
      if (this.controlB?.control.hasError('aLessThanB')) {
        this.controlB?.control.setErrors(null);
      }
    }
  }

  validate(): ValidationErrors | null {
    const current = this.controlA?.control.value;
    const previous = this.controlB?.control.value;
    if (
      current != null &&
      previous != null &&
      typeof current === 'number' &&
      typeof previous === 'number' &&
      current < previous
    ) {
      return { aLessThanB: true };
    }

    return null;
  }
}
